import UPDATE_BILLING_INFO from "./update-subscription-billing-info.graphql";
import INVOICE_QUOTE_REQUEST from "./request-quote.graphql";

const subscriptionService = ({ gqlClient }) => {
	const updateBillingInfo = ({
		subscriptionId: subscriptionID,
		billingCountryID,
		billingName,
		billingEmail,
		billingCompany,
		billingDepartment,
		billingAddress1,
		billingAddress2,
		billingCity,
		billingState,
		billingZipCode,
		billingPhoneNumber,
	}) =>
		gqlClient(UPDATE_BILLING_INFO, {
			subscriptionID,
			billingInfoInput: {
				billingCountryID,
				billingName,
				billingEmail,
				billingCompany,
				billingDepartment,
				billingAddress1,
				billingAddress2,
				billingCity,
				billingState,
				billingZipCode,
				billingPhoneNumber,
			},
		});

	const requestQuote = request => gqlClient(INVOICE_QUOTE_REQUEST, { request });

	return { updateBillingInfo, requestQuote };
};

export default subscriptionService;
